import { render, staticRenderFns } from "./LiveActivity.vue?vue&type=template&id=6324776a&scoped=true"
import script from "./LiveActivity.vue?vue&type=script&lang=js"
export * from "./LiveActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6324776a",
  null
  
)

export default component.exports